import { AnswerTrackerType } from './answer.tracker.type'
import { SingleTrackerType } from './single.tracker.type'

export type TrackerType = AnswerTrackerType | SingleTrackerType;
export const TrackerType = {
  ...AnswerTrackerType,
  ...SingleTrackerType
}
